export const themeColors = {
  default: 'default',
  black: 'black',
  purple: 'purple',
  orange: 'orange',
} as const;

export type ThemeColor = keyof typeof themeColors;

export const getThemeColor = (value: ThemeColor): string => {
  return themeColors[value];
};
